<template>
  <div v-if="invito.visibile.value" class="flex flex-col gap-2 rounded-xl border border-accent/30 bg-accent/10 p-3" role="region" :aria-label="t('centro_notifiche.invito_push.titolo')" data-test="invito-push">
    <p class="flex items-start gap-2 text-sm font-medium text-text-primary"><i class="fal fa-bell-on mt-0.5 text-text-accent" aria-hidden="true" />{{ t("centro_notifiche.invito_push.titolo") }}</p>
    <p class="text-xs text-text-secondary" data-test="invito-push-testo">{{ invito.daInstallare.value ? t("centro_notifiche.invito_push.ios") : t("centro_notifiche.invito_push.testo") }}</p>
    <div class="flex flex-wrap justify-end gap-2 max-sm:flex-col">
      <UiButton variant="ghost" size="sm" :label="invito.daInstallare.value ? t('centro_notifiche.invito_push.capito') : t('centro_notifiche.invito_push.non_ora')" data-test="invito-push-non-ora" @click="invito.nonOra" />
      <UiButton v-if="invito.attivabile.value" size="sm" icon="fal fa-bell" :label="t('centro_notifiche.invito_push.attiva')" :loading="invito.inCorso.value" data-test="invito-push-attiva" @click="invito.attiva" />
    </div>
  </div>
</template>

<script setup lang="ts">
// Invito a ricevere le notifiche push su questo dispositivo, in cima alla tendina della campanella e alla pagina Notifiche. Compare una sola volta per browser e
// solo se le push si possono attivare; «Attiva» chiede il permesso al browser subito, dal clic (vincolo di iOS). Niente popup all'accesso.
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const invito = useInvitoPush();
</script>
